import React from "react";
import ResourcePage from "@/components/ResourcePage";
import { COUNTRIES } from "@/lib/api";

const SOURCES = ["Website", "Product page", "Direct enquiry", "Referral", "Trade show", "Email", "WhatsApp", "Other"];
const STATUSES = ["NEW", "CONTACTED", "QUALIFIED", "RFQ", "QUOTATION", "NEGOTIATION", "WON", "LOST"];

export default function Leads() {
  return (
    <ResourcePage
      title="Leads" name="Lead" endpoint="leads"
      subtitle="Move every enquiry through your export sales pipeline"
      emptyMessage="No leads yet. Once an international buyer shows interest, their lead will appear here."
      canExport relations={["buyers", "products", "users"]}
      statusOptions={STATUSES}
      convert={{ endpoint: (id) => `leads/${id}/convert-to-rfq`, to: "/rfqs", label: "To RFQ", toast: "RFQ created", resultKey: "rfq_number" }}
      columns={[
        { key: "lead_number", label: "Lead ID", type: "mono" },
        { key: "buyer_name", label: "Buyer" },
        { key: "country", label: "Country" },
        { key: "product_name", label: "Product" },
        { key: "assigned_name", label: "Owner" },
        { key: "lead_value", label: "Value", type: "currency" },
        { key: "priority", label: "Priority", type: "status" },
        { key: "status", label: "Status", type: "status" },
      ]}
      defaultValues={{ status: "NEW", priority: "Medium", lead_source: "Website", lead_value: 0 }}
      formFields={[
        { name: "buyer_id", label: "Buyer", type: "relation", source: "buyers", required: true },
        { name: "product_id", label: "Product", type: "relation", source: "products" },
        { name: "country", label: "Country", type: "select", options: COUNTRIES },
        { name: "lead_source", label: "Lead source", type: "select", options: SOURCES },
        { name: "assigned_to", label: "Assigned to", type: "relation", source: "users" },
        { name: "lead_value", label: "Lead value (₹)", type: "number" },
        { name: "priority", label: "Priority", type: "select", options: ["High", "Medium", "Low"] },
        { name: "status", label: "Status", type: "select", options: STATUSES },
        { name: "next_followup_date", label: "Next follow-up", type: "date" },
        { name: "notes", label: "Notes", type: "textarea", full: true },
      ]}
    />
  );
}
